import React from "react";
import { Navigate } from "react-router-dom";
import { useAdminAuth } from "../../hooks/useAdminAuth";

interface AdminProtectedRouteProps {
  children: React.ReactNode;
  redirectTo?: string;
}

/**
 * 관리자 인증이 필요한 페이지를 보호하는 컴포넌트
 * 관리자로 로그인하지 않은 사용자는 지정된 경로로 리다이렉트
 */
const AdminProtectedRoute: React.FC<AdminProtectedRouteProps> = ({
  children,
  redirectTo = "/admin/auth",
}) => {
  const { isAdminLoggedIn, checkAdminAuth } = useAdminAuth();

  // 관리자 인증 상태 확인
  const isAuthenticated = isAdminLoggedIn || checkAdminAuth();

  // 관리자로 로그인하지 않은 경우 관리자 로그인 페이지로 리다이렉트
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} replace />;
  }

  // 관리자로 로그인한 사용자에게는 자식 컴포넌트 렌더링
  return <>{children}</>;
};

export default AdminProtectedRoute;
